var commonLinks = {
    INSTRUCTION: "MANUAL",
    SERVICE: "SERVICE",
    CONTACT: "CONTACT",
};

var commonLabels = {
    Time_Of_Sending_To_OSP: "Time of sending to OSP",
    Open: "Open",
    View: "View",
    Display: "Display",
    Edit: "Edit",
    Delete: "Delete",
    Cancel: "Cancel",
    Add: "Add",
    Confirm: "Confirm",
    MDM: "MDM",
    MDMs: "MDMs",
    Id: "ID",
    Name: "Name",
    Short_Name: "Short name",
    OSD: "OSD",
    OSD_Department: "OSD department",
    Medium_Type: "Medium Type",
    No_Data: "&lt;no_data&gt;",
    Identification: "Identification",
    Delete_Object: "Do you want to delete this object?",
    Code: "Code",
    Comment: "Comment",
    Error: "Error",
    Save: "Save",
    Save_Changes: "Save changes",
    Add_New: "Add",
    New_Window: "New window",
    Changelog: "Changelog",
    Select: "Select",
    Type: "Type",
    PPE_Code: "PPE Code",
    CSPR_Code: "CSPR Code",
    Object_Code: "Object Code",
    Users: "Users",
    Data: "Data",
    Sum: "Sum",
    Size: "Size",
    Save_Filter: "Save Filter",
    Delete_Filter: "Delete Filter",
    Filter_Name_Question: "Enter filter name",
    Select_Filter: "Select filter",
    Date_From: "Date from",
    Date: "Date",
    Date_To: "Date to",
    Refresh: "Refresh",
    Related_Documents: "Related Documents",
    Operations: "Actions",
    Download: "Download",
    Close: "Close",
    Hour: "Hour",
    Consumption: "Consumption",
    Status: "Status",
    Licence_Number: "Licence Number",
    Time: "Time",
    Lp: "No.",
    Winter_Time: "Winter",
    Summer_Time: "Summer",
    Version: "Version",
    Header: "Header",
    Answer: "Answer",
    Man_Position: "Position",
    Phone: "Phone",
    Fax: "Fax",
    Count: "Count",
    Value: "Value",
    Reset_Grid_View: "Reset view",
    Document_Change_History: "Document changes history",
    Changes_History: "Changes history",
    Conflicts: "Conflicts",
    Init: "No object",
    Microinstallation: "Microinstallation",
    Period_Method: "Period method",
    Data_Source: "Data source",
    Contractor: "Contractor",
    Deleted: "Deleted",
    Serial: "Serial",
    Client_ID: "Client ID",
    Excise_ID: "Excise ID",
    Attachment_ID: "Attachment ID",
    References: "References",
    AdditionalParameters: "Additional arameters",
    Day: "Day",
    Week: "Week",
    Month: "Month",
    "Three months": "Three months",
    "Half a year": "Half a year",
    Year: "Year",
    Information: "Information",
    Copy: "Copy",
    Copy_From: "Copy From",
    Copy_To: "Copy To",
    New: "New",
    Loading: "Loading",
    CopyToClipboard: "Copy to clipboard",
    CopiedToClipboard: "Copied to clipboard",
    Change_Secret_Value: "Change secret value in appsettings.json",
    Validate: "Validate"
};

var pages = {
    Page_Not_Found: "Page not found",
    Access_Denied: "Access to page is not permitted",
    Under_Construction: "This page is under construction",
};

var signInPage = {
    Username: "Login",
    Password: "Password",
    Sign_In: "Sign In",
    Remember_Me: "Remember me",
    Remind_Password: "Password forgotten?",
    Wrong_Password: "Wrong username/password",
    User_Block: "User is blocked",
    User_Unblock: "User is unblocked",
    Logging_In: "Logging in to:",
    User_NoRole: "User doesn't have role for this application",
};

var dropdownUser = {
    Password_Change: "Change password",
    Profile: "Profile",
    Sign_Out: "Sign Out",
};

var signOutScreen = {
    Logged_Out: "Signed Out",
};

var httpErrors = {
    Error_400: "HTTP 400: Bad Request",
    Error_401: "HTTP 401: Unauthorized",
    Error_403: "HTTP 403: Forbidden",
    Error_404: "HTTP 404: Not Found",
    Error_405: "HTTP 405: Method Not Allowed",
    Error_412: "HTTP 412: Precondition Failed",
    Error_415: "HTTP 415: Unsupported Media Type",
    Error_500: "HTTP 500: Internal Server Error",
    Error_501: "HTTP 501: Not Implemented",
};

var serviceScreen = {
    Service: "Service",
    API_Doc: "API adress",
    Ping: "Ping",
    DB_Connection_Status: "DB connection status",
    Connected: "Connected",
    Disconnected: "Disconnected",
    Log: "Log",
    Log_Settings: "Log settings",
    Report_Problem: "Report a problem",
    ServiceScreen: "Service Screen ",
};

var address = {
    Street: "Street",
    ZipCode: "ZIP code",
    City: "City",
    Province: "Province",
    District: "District",
    Commune: "Commune",
    Block_Nr: "Building number",
    Apartment_Nr: "Apartment number",
    Address: "Address",
    Parcel: "Parcel",
};

var changes = {
    FieldName: "Field name",
    PrevValue: "Previous value",
    NextValue: "Next value",
    Event: "Event",
};

var user = {
    User: "User",
    Users: "Users",
    UserID: "User ID",
    Firstname: "Name",
    Surname: "Surname",
    Login: "Login",
    Yes: "Yes",
    No: "No",
    Blocked: "Blocked",
    Email: "E-mail address",
    Register_Date: "Register date",
    Last_Login_Date: "Last login date",
    Phone_Number: "Phone Number",
    Organization: "Organization",
    IsAdmin: "Admin",
    Password_Used: "The password was already in use",
    Changes_History: "Changes History",
};

var counter = {
    Counter: "Counter",
    Tariff_Group: "Tariff Group",
    OSD_Tariff_Group: "OSD Tariff Group",
    Multiplicand: "Multiplicand",
    Counterwidth: "Counterwidth",
    Meterdevice_ID: "Meterdevice ID",
};

var account = {
    Password_Change: "Password change",
    Old_Password: "Old Password",
    New_Password: "New password",
    Confirm_Password: "Confirm Password",
    Application: "Application",
    Applications: "Applications",
    Role: "Role",
    Domain_login: "Domain login",
};

var userMessages = {
    Email_Taken: "Email is already taken",
    DuplicateUserName: "Username is already taken",
    InvalidUserName: "Invalid username",
    Email_Null: "Email is required",
    PasswordTooShort: "Password must be at least 6 characters",
    PasswordRequiresNonAlphanumeric:
        "Password must have at least one non alphanumeric character",
    PasswordRequiresDigit: "Password must have at least one digit",
    PasswordRequiresLower: "Password must have at least one lowercase letter",
    PasswordRequiresUpper: "Password must have at least one uppercase letter",
    PasswordRequiresUniqueChars:
        "Password must use at least 3 different characters",
    Name_Null: "Name is required",
    Password_Null: "Password is required",
    ConfirmPassword_Null: "Confirm password is required",
    Passwords_Arent_Equal: "Passwords aren't equal",
    "Incorrect Password.": "Incorrect password.",
    Wrong_Password_Confirmation: "New passwords are not the same.",
    Not_All_Password_Field: "Not all passwords fields were filled.",
    "Controller::ClientDBErorr": "Database connection error",
    "Controller::RemoveAddedRoles": "Removing added role error",
    "Controller::DeleteRoles": "Removing role error",
    "Controller::AddRoles": "Adding role error",
    "Controller::RoleNotFound": "Role not found",
    "Controller::ApplicationNotFound": "Application not found",
    PasswordMismatch: "Incorrect password",
    InvalidEmailFormat: "Invalid email format",
    InvalidPhoneNumberFormat: "Invalid phone number format",
    Password_Changed: "Password changed",
};

var chart = {
    ChartTypeBar: "Bar",
    ChartTypeLine: "Line",
    ChartTypeStepArea: "Step Area",
    ResetZoom: "Reset zoom",
    Measure_activeEnergy: "Active energy [kWh]",
    Measure_activePower: "Active power [kW]",
    Measure_passiveEnergy: "Passive energy [kVArh]",
    Measure_passivePower: "Passive power [KVAr]",
    Measure_volume: "Volume [m^3]",
    Measure_flow: "Flow [m^3/h]",
    ChartData_Energy: "Energy",
    ChartData_Power: "Power",
    Format: "Format",
};

var contact = {
    Contact: "Contact",
};

var buttons = {
    XML_View: "View XML",
    Export_To_XLSX: "Export to XLSX",
    Send_XLSX: "Send e-mail with XLSX",
    Delete_Document: "Delete document",
    Make_Copies: "Make copy",
    Save_Draft: "Save draft",
    Save_And_Send: "Save and send",
};

var documentActionResult = {
    ok: "Action for document with ID =%d completed successfully",
    forbidden:
        "No permission to perform an action for the document with ID =%d",
    forbidden_status:
        "Action not allowed due to document status for document with ID=%d",
    error: "Action execution error for the document with ID=%d : %d",
};

var notifications = {
    Notifications: "Notifications",
    Group: "Group",
    EmailNotifier: "Email",
    PushNotifier: "Push",
    RssNotifier: "Rss",
    AppNotifier: "Application",
    RSS_Subscription: "Rss subscription",
    MessageTemplate: "Message template",
    NotificationMessageTemplates: "Notification message template",
    Title: "Title",
    Text: "Text",
    Lang: "Language",
    Group1: "Main group",
    Group2: "Subgroup",
};

var langs = {
    gb: "english",
    pl: "polish",
};

var localeGB = {
    ...commonLinks,
    ...commonLabels,
    ...pages,
    ...signInPage,
    ...dropdownUser,
    ...signOutScreen,
    ...httpErrors,
    ...serviceScreen,
    ...address,
    ...changes,
    ...user,
    ...counter,
    ...account,
    ...userMessages,
    ...chart,
    ...contact,
    ...buttons,
    ...documentActionResult,
    ...notifications,
    ...langs,
};

export default localeGB;
